export const GLOSSARY = {
    FCI: "Facility Condition Index",
    EFCI: "Extended Facility Condition Index",
    DM: "Deferred Maintenance",
    FC: "Future Capital",
    CRV: "Current Replacement Value",
    CSP: "Capital Spending Plan",
    SF: "Square Feet",
    FCA: "Facility Condition Assessment",
    Recom: "Recommendation",
    TOC: "Total Opinions of Cost",
    ADC: "Asset Data Collection"
};

export const WithTooltip = ({ children }) => {
    const renderWithTooltip = text => {
        const regex = new RegExp(`\\b(${Object.keys(GLOSSARY).join("|")})\\b`, "g");

        return text.split(regex).map((part, index) => {
            const fullForm = GLOSSARY[part];
            if (fullForm) {
                return (
                    <span className="glossary-term" key={index} data-for="glossary" data-tip={fullForm}>
                        {part}
                    </span>
                );
            }

            return part;
        });
    };

    return (
        <>
            <span>{renderWithTooltip(children)}</span>
        </>
    );
};
